
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CdkFavorite extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  isFavorite: boolean;

  get favoriteIcon() {
    if (this.isFavorite) {
      return "star";
    }
    return "star_outline";
  }
}
